<!-- eslint-disable max-len -->
<template>
  <div>
    <edit-page
      name="Coupon"
      param="couponId"
      page-prefix="/blade/coupons"
      model-name="coupon"
      :create="createCoupon"
      :fetch="getCouponWithParams"
      :update="updateCoupon"
      :remove="deleteCoupon"
      :stub="couponStub"
      :validator="validator"
      :utils="{}">
      <template slot-scope="{ model, validator }">
        <text-input label v-model.trim="model.name" :validator="validator.name" required autofocus>Name</text-input>
        <text-input label v-model.trim="model.description">Description</text-input>

        <checkbox-input v-if="creating" v-model="model.shouldGenerateCode">Generate Code</checkbox-input>
        <text-input v-if="model.shouldGenerateCode" disabled label value="Will be generated automatically">Code</text-input>
        <text-input v-else label v-model.trim="model.code">Code</text-input>

        <checkbox-input @input="updateValue(model.value, model)" v-model="model.isPercentage">Percentage</checkbox-input>
        <template v-if="model.isPercentage">
          <text-input label @blur="updateValue(model.value, model, true)" @input="(e)=>updateValue(e, model)" :value="model.value.toString()" :validator="validator.value">Discount Percentage (0-1)</text-input>
        </template>
        <template v-else>
          <text-input label @blur="updateValue(model.value, model, true)" @input="(e)=>updateValue(e, model)" :value="model.value.toString()" :validator="validator.value">Discount in USD</text-input>
        </template>

        <checkbox-input @input="(e)=>updateMaxUses(e, model)" :value="model.maxUses >= 0">Enforce Max Uses</checkbox-input>
        <number-input v-if="model.maxUses >= 0" label v-model="model.maxUses">Max Uses</number-input>
      </template>
    </edit-page>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

import EditPage from '../../ui/pages/EditPage';
import SelectInput from '../../ui/inputs/SelectInput';
import TextInput from '../../ui/inputs/TextInput';
import NumberInput from '../../ui/inputs/NumberInput';
import CheckboxInput from '../../ui/inputs/CheckboxInput';

export default {
  components: {
    EditPage,
    SelectInput,
    TextInput,
    CheckboxInput,
    NumberInput
  },
  data() {
    return {
      couponStub: {
        _id: '',
        name: '',
        description: '',
        code: '',
        shouldGenerateCode: false,
        isPercentage: false,
        value: 0,
        maxUses: -1
      },
      validator: {
        name: { required },
        value: {
          required
        }
      }
    };
  },
  computed: {
    creating() {
      return !(this.$route.params.couponId);
    },
  },
  methods: {
    ...mapActions([
      'getCoupon',
      'createCoupon',
      'updateCoupon',
      'deleteCoupon'
    ]),

    async getCouponWithParams(params) {
      return Object.assign(this.couponStub, await this.getCoupon(params));
    },
    /**
     * @param {String} value
     */
    updateValue(value, coupon, forceUpdate) {
      /** @type {Number} */
      if (value === '') return;

      const valueString = value.toString();
      const numberMatch = /([0-9]*)(\.[0-9]*)?/g;
      const matched = valueString.match(numberMatch);
      if (matched.length === 0 || matched[0] !== valueString) {
        console.log(`${valueString} did not match ${numberMatch}`);
        const old = coupon.value;
        coupon.value = NaN;
        coupon.value = old;
        return;
      }

      let parsed = parseFloat(value);
      if (!isNaN(parsed)) {
        if (coupon.isPercentage) {
          parsed = Math.min(Math.max(parsed, 0), 1);
        }

        if (parsed === coupon.value) return;
        if (forceUpdate) coupon.value = NaN;
        coupon.value = parsed;
      } else {
        // Force display update
        const prev = coupon.value;
        coupon.value = NaN;
        coupon.value = prev;
      }
    },
    /**
     * @param {Boolean} value
     */
    updateMaxUses(value, coupon) {
      if (value) {
        coupon.maxUses = 1;
      } else {
        coupon.maxUses = -1;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-image-background + span {
  display: block;
  margin: -10px 0 10px 10px;
}
.form-image-background {
  background-color: rgba(0, 0, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/CouponEdit.vue